import { UserIcon } from '@figure/figure-frontlib-gui';

export const TYPES = [
  { value: 'HOMEOWNER', label: 'Homeowner', icon: <UserIcon /> },
  { value: 'RENT', label: 'Rent', icon: <UserIcon /> },
  { value: 'PARENTS', label: 'Live with others', icon: <UserIcon /> },
];
